import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Hand, Dices, Target, Play } from "lucide-react";
import { auth, getStoredUser } from "../lib/api";
import { PenaltyTopBar } from "./PenaltyMatch";
import { PenaltyScene } from "../components/penalty/PenaltyScene";
import AuthForm from "../components/AuthForm";
import PepPicker from "../components/PepPicker";
import { GAMES } from "../components/WagerPicker";
import { Toaster } from "../components/ui/toaster";

const STEPS = [
  { Icon: Dices, t: "Spin for a taker & keeper" },
  { Icon: Target, t: "Swipe up to shoot" },
  { Icon: Hand, t: "Swipe to dive and save" },
];

export default function PenaltyLobby() {
  const navigate = useNavigate();
  const [coins, setCoins] = useState(getStoredUser()?.coins ?? null);
  const [user, setUser] = useState(undefined);
  const [picking, setPicking] = useState(true);

  useEffect(() => {
    auth.ensure().then((u) => { setUser(u); if (u) setCoins(u.coins); }).catch(() => setUser(null));
  }, []);

  return (
    <div className="min-h-screen" data-testid="penalty-lobby-page">
      <PenaltyTopBar coins={coins} onBack={() => navigate("/")} />
      <div className="max-w-md mx-auto px-4 py-6">
        <div className="relative">
          <PenaltyScene keeperKit={{ short: "MUN", color: "#DA291C" }} caption="Best of 5 · sudden death" />
        </div>
        <h1 className="font-display font-extrabold text-3xl sm:text-4xl text-white mt-5">Penalty Shootout</h1>
        <p className="text-slate-400 text-sm mt-1">Stake virtual £, send a link, beat your mate from 12 yards. Winner doubles their stake.</p>
        <div className="grid grid-cols-3 gap-2 mt-4">
          {STEPS.map(({ Icon, t }) => (
            <div key={t} className="rounded-xl bg-white/5 border border-white/10 px-2 py-3 text-center">
              <Icon className="w-5 h-5 mx-auto text-[#38BDF8]" />
              <div className="text-[11px] text-slate-300 mt-1 leading-tight">{t}</div>
            </div>
          ))}
        </div>
        {user === null ? (
          <div className="mt-5">
            <AuthForm onAuthed={(u) => { setUser(u); setCoins(u.coins); }} title="Sign up to play penalties" />
          </div>
        ) : (
          <button
            data-testid="shootout-choose-stake-btn"
            onClick={() => setPicking(true)}
            className="btn-green wager-glow w-full rounded-xl py-4 mt-5 font-extrabold text-lg flex items-center justify-center gap-2"
          >
            <Play className="w-5 h-5 fill-current" /> Choose your stake
          </button>
        )}
      </div>
      {user && <PepPicker open={picking} game={GAMES[1]} user={{ ...user, coins: coins ?? user.coins }} onClose={() => setPicking(false)} />}
      <Toaster />
    </div>
  );
}
